var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputIconName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79004 7.2C4.79004 3.22355 8.01359 0 11.99 0C15.9665 0 19.19 3.22355 19.19 7.2C19.19 11.1764 15.9665 14.4 11.99 14.4C8.01359 14.4 4.79004 11.1764 4.79004 7.2Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10716 17.883C6.05708 17.0655 8.65799 16.8 11.99 16.8C15.3152 16.8 17.9122 17.0645 19.8604 17.8777C21.9515 18.7506 23.235 20.2335 23.9192 22.3904C24.1734 23.192 23.5722 24 22.7411 24H1.23154C0.403819 24 -0.193817 23.1956 0.0583148 22.3985C0.740479 20.2417 2.01946 18.7581 4.10716 17.883Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIconName);
export default __webpack_public_path__ + "static/media/input_icon_name.77e746310741020513af5b6e32879808.svg";
export { ForwardRef as ReactComponent };